
import api from '@/api';
import _ from 'lodash';

const namespaced = true;

const state = {
  makers: [],
  currentUserMakers: [],
};

const mutations = {
  SET_MAKERS(state, makers) {
    state.makers = makers;
  },
  SET_CURRENT_USER_MAKERS(state, makers) {
    state.currentUserMakers = makers;
  },
};

const actions = {
  async fetchMakers({ commit }) {
    const { data: makers } = await api.get(`/makers`);

    commit(`SET_MAKERS`, makers);
    return makers;
  },
  async fetchMakersForClient({ commit }, clientId) {
    const { data: makers } = await api.get(`/makers/client/${clientId}`);

    commit(`SET_MAKERS`, makers);
    return makers;
  },
  async fetchListForClient(store, clientId) {
    const { data: makers } = await api.get(`/makers/client/${clientId}`);

    return makers;
  },
  async fetchOne(store, makerId) {
    const { data: maker } = await api.get(`/makers/${makerId}`);

    return maker;
  },
  async fetchTagsForClient(store, { makerId, clientId }) {
    try {
      const { data: tags } = await api.get(`/tags/client/${clientId}/maker/${makerId}`);

      return tags;
    } catch (e) {
      return [];
    }
  },
  async assignTagToClientMaker(store, { clientId, makerId, tagId }) {
    try {
      await api.post(`/tags/client/${clientId}/maker/${makerId}`, { id: tagId });
    } catch (e) {} // eslint-disable-line
  },
  async unassignTagToClientMaker(store, { clientId, makerId, tagId }) {
    try {
      await api.delete(`/tags/client/${clientId}/maker/${makerId}/tag/${tagId}`);
    } catch (e) {} // eslint-disable-line
  },
  async fetchCurrentUserMakers({ commit, rootState }) {
    try {
      const { data: makers } = await api.get(`/makers/user/${rootState[`model/user`].currentUser.id}`);
      commit(`SET_CURRENT_USER_MAKERS`, makers);

      return makers;
    } catch (e) {
      return [];
    }
  },
  async checkIfHasEmail(store, makerId) {
    try {
      const { data: { hasEmail } } = await api.get(`/makers/${makerId}/has-email`);

      return hasEmail;
    } catch (e) {
      return false;
    }
  },
};

const getters = {
  getMaker: state => id => _.find(state.makers, maker => _.toInteger(maker.id) === _.toInteger(id)) || null,
  writeMakers(state) {
    return _.filter(state.makers, maker =>
      maker.right.id === 3
    );
  },
};

export default {
  namespaced, state, mutations, actions, getters,
};
